import MotionSection from "../common/MotionSection";
import SectionHeading from "../common/SectionHeading";
import { aboutPageData } from "../../data/aboutData";

function AboutStory() {
  const { story } = aboutPageData;

  return (
    <MotionSection className="py-16 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-6">
        <div className="grid gap-8 lg:grid-cols-[0.9fr_1.1fr] lg:items-start">
          <div className="signature-card rounded-[1.8rem] p-6 md:p-8">
            <SectionHeading center={false} kicker="Our Story" title={story.title} description={story.intro} />

            <div className="mt-6 rounded-2xl bg-sky-glow/70 p-5">
              <p className="text-sm leading-relaxed text-slate-text/85 md:text-base">
                We are not here to overwhelm students with options. We are here to design a practical, confident,
                and personalized path to the right global opportunity.
              </p>
            </div>
          </div>

          <div className="space-y-4">
            {story.chapters.map((chapter, index) => (
              <article
                key={chapter.title}
                className="signature-card signature-card-interactive rounded-2xl p-5 md:p-6"
              >
                <div className="flex items-start gap-3">
                  <span className="inline-flex h-8 w-8 flex-none items-center justify-center rounded-full bg-royal-blue text-xs font-bold text-soft-white">
                    {`0${index + 1}`}
                  </span>
                  <div>
                    <h3 className="text-xl leading-tight">{chapter.title}</h3>
                    <p className="mt-2 text-sm leading-relaxed text-slate-text/85 md:text-base">{chapter.text}</p>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </MotionSection>
  );
}

export default AboutStory;
